module.exports = __webpack_public_path__ + "static/img/fpypos.58608c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/fpypos.png
// module id = DwTL
// module chunks = 1